import React from 'react';
import { Card, Grid, Stack } from '@mui/material';
import TransactionDetailSection from 'components/_dashboard/transactions/TransactionDetailSection';
import TicketInfoSection from 'components/_dashboard/transactions/TicketInfoSection';
import MaterialDetailSection from 'components/_dashboard/transactions/MaterialDetailSection';
import ProblemSection from 'components/_dashboard/transactions/ProblemSection';
import ActionButtons from 'components/_dashboard/transactions/ActionButtons';
import {
  BaseSectionProps,
  TicketInfoSectionProps,
  ProblemSectionProps,
  ActionButtonsProps
} from '../../@types/transactions';

interface TransactionDetailsTabProps {
  formProps: {
    values: any;
    touched: any;
    errors: any;
    getFieldProps: (field: string) => any;
    setFieldValue?: (field: string, value: any) => void;
    isEdit: boolean;
  };
  ticketInfoProps: Omit<TicketInfoSectionProps, keyof BaseSectionProps>;
  problemProps: Omit<ProblemSectionProps, keyof BaseSectionProps>;
  actionButtonsProps: ActionButtonsProps;
}

const TransactionDetailsTab: React.FC<TransactionDetailsTabProps> = ({
  formProps,
  ticketInfoProps,
  problemProps,
  actionButtonsProps
}) => (
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <Card sx={{ p: 3 }}>
        <Stack spacing={4}>
          <TransactionDetailSection
            values={formProps.values}
            touched={formProps.touched}
            errors={formProps.errors}
            getFieldProps={formProps.getFieldProps}
            setFieldValue={formProps.setFieldValue}
            isEdit={formProps.isEdit}
          />
          <TicketInfoSection
            values={formProps.values}
            touched={formProps.touched}
            errors={formProps.errors}
            getFieldProps={formProps.getFieldProps}
            setFieldValue={formProps.setFieldValue}
            isEdit={formProps.isEdit}
            bridgeIdentity={ticketInfoProps.bridgeIdentity}
            drivers={ticketInfoProps.drivers}
            vehicleReg={ticketInfoProps.vehicleReg}
            haulier={ticketInfoProps.haulier}
            client={ticketInfoProps.client}
          />
          <MaterialDetailSection
            values={formProps.values}
            touched={formProps.touched}
            errors={formProps.errors}
            getFieldProps={formProps.getFieldProps}
            isEdit={formProps.isEdit}
          />
          <ProblemSection
            values={formProps.values}
            touched={formProps.touched}
            errors={formProps.errors}
            getFieldProps={formProps.getFieldProps}
            setFieldValue={formProps.setFieldValue}
            problems={problemProps.problems}
          />
          <ActionButtons
            isSubmitting={actionButtonsProps.isSubmitting}
            isEdit={actionButtonsProps.isEdit}
            disableSubmit={actionButtonsProps.disableSubmit}
            onClose={actionButtonsProps.onClose}
            copiedInfo={actionButtonsProps.copiedInfo}
          />
        </Stack>
      </Card>
    </Grid>
  </Grid>
);

export default TransactionDetailsTab;
